import fetchWithAuthorization from './fetch-with-authorization'
import { END_POINTS } from './end-points'

export const fetchRewardsGroups = async (page = 1, perPage = 100) => {
  const path = END_POINTS.REWARDS_GROUP.GET_GROUPS(page, perPage)
  const response = await fetchWithAuthorization({
    path,
  })
  return { data: response.data, meta: response.meta }
}

export const fetchAllRewardGroups = async (page = 1, allGroups = [], perPage = 100) => {
  const { data } = await fetchRewardsGroups(page, perPage)
  const combinedGroups = [...allGroups, ...data]

  if (data.length < perPage) {
    return combinedGroups
  } else {
    return fetchAllRewardGroups(page + 1, combinedGroups)
  }
}

export const createRewardsGroup = async groupData => {
  const response = await fetchWithAuthorization({
    path: END_POINTS.REWARDS_GROUP.CREATE_GROUP,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(groupData),
  })

  return response
}

export const updateRewardsGroup = async ({ ruleGroup, updateData }) => {
  const response = await fetchWithAuthorization({
    path: `${END_POINTS.REWARDS_GROUP.UPDATE_GROUP}${ruleGroup}`,
    method: 'PUT',
    body: JSON.stringify(updateData),
  })

  return response
}
